/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Days_Fixed_VariableInputs */

const en_us2_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Different days each week`)
};

const pt_br2_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dias variam a cada semana`)
};

const es_419_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los días cambian cada semana`)
};

const pt_pt2_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dias variam de semana para semana`)
};

const fr_fr2_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des jours différents chaque semaine`)
};

const de_de2_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Woche andere Tage`)
};

const it_it2_onboarding_days_fixed_variable = /** @type {(inputs: Onboarding_Days_Fixed_VariableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni diversi ogni settimana`)
};

/**
* | output |
* | --- |
* | "Different days each week" |
*
* @param {Onboarding_Days_Fixed_VariableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_days_fixed_variable = /** @type {((inputs?: Onboarding_Days_Fixed_VariableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Days_Fixed_VariableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_days_fixed_variable(inputs)
	if (locale === "es-419") return es_419_onboarding_days_fixed_variable(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_days_fixed_variable(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_days_fixed_variable(inputs)
	if (locale === "de-DE") return de_de2_onboarding_days_fixed_variable(inputs)
	if (locale === "it-IT") return it_it2_onboarding_days_fixed_variable(inputs)
	return en_us2_onboarding_days_fixed_variable(inputs)
});
export { onboarding_days_fixed_variable as "onboarding.days_fixed.variable" }